import { styled } from '@mui/material/styles';
import MuiDialogContent from '@mui/material/DialogContent';

export const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  color: '#373737',
  padding: theme.spacing(0, 4.5),
  '& > ul': {
    paddingLeft: theme.spacing(2),
    '& > li': {
      marginBottom: theme.spacing(2),
    },
  },
  '&:last-child': {
    paddingBottom: theme.spacing(6),
  },
}));
